export default function WarehouseInchargeForm() {
  return (
    <div className="job-form-container">
      <h1>Apply – Warehouse Incharge</h1>
      <p>Inventory & logistics management</p>

      <div className="job-form-grid">
        <input placeholder="Full Name" />
        <input placeholder="Phone Number" />
        <input placeholder="Warehouse Size Managed (sq ft)" />
        <input placeholder="Inventory Software Experience" />
        <input placeholder="Years of Experience" />
        <textarea placeholder="Warehouse Management Experience" />
      </div>

      <button>Submit Application</button>
    </div>
  );
}
